import { Box, InlineStack } from '@customerio/pluma-components/react';
import type { ApiCredential } from '@/services/db/api-credential/entity';
import { type ConnectionState, isDeleteDisablePossible } from '../connection-status';
import { SegmentMainControl, SegmentOptionsMenu } from './segment-connect-action';

type SegmentActionsRowProps = {
  state: ConnectionState;
  selectedCredential: ApiCredential | null;
  isBusy: boolean;
  /** `journeys/segment_integration/create` — the main control. */
  canIntegrate: boolean;
  /** `journeys/segment_integration/edit` — the Options menu. */
  canEdit: boolean;
  /** `journeys/segment_integration/delete` — the Delete item. */
  canDelete: boolean;
  onConnect: () => void;
  onDisable: () => void;
  onDelete: () => void;
};

/**
 * The Options menu beside the main control.
 *
 * The menu is absent outside the states that have a destination to act on, so the
 * row is the main control alone for a workspace that has never connected.
 */
export function SegmentActionsRow({
  state,
  selectedCredential,
  isBusy,
  canIntegrate,
  canEdit,
  canDelete,
  onConnect,
  onDisable,
  onDelete,
}: SegmentActionsRowProps) {
  const hasCredential = selectedCredential != null;

  return (
    <Box mb="150">
      <InlineStack alignBlock="center" gap="100">
        {!isDeleteDisablePossible(state) ? null : (
          <SegmentOptionsMenu
            state={state}
            isDisabled={isBusy || !canEdit || !hasCredential}
            canDelete={canDelete}
            onDisable={onDisable}
            onDelete={onDelete}
          />
        )}
        <SegmentMainControl
          state={state}
          hasCredential={hasCredential}
          canIntegrate={canIntegrate}
          isBusy={isBusy}
          onConnect={onConnect}
        />
      </InlineStack>
    </Box>
  );
}
